import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { graphql } from "@apollo/client/react/hoc";
import { PROVIDERS_QUERY } from "Services/queries";
import withDefaultParams from "Services/withDefaultParams";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import ProviderItem from "ComponentsUI/ProviderItem/ProviderItem";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { v4 } from "uuid";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";

@inject("ApplicationModel")
@observer
class Providers extends React.Component {
	generateProviderRatesUrl(data) {
		if (data) {
			let providerRatesUrl = generateUrl(Routes.ProviderRates.route, {
				providerName: data.url_name,
				regionUrl: data.region.url,
			});
			return providerRatesUrl;
		}
		return "/";
	}

	render() {
		const {
			data,
			ApplicationModel: {
				windowSizeModel: { windowSizes },
				text,
			},
		} = this.props;

		if (!data?.providers?.data.length) {
			return null;
		}

		return (
			<PaddingBottom>
				<Container>
					<HeaderTextSeo
						header={this.props.seoBlock?.seoHeader}
						text={this.props.seoBlock?.seoText}
						bgText={true}
					/>
					<Row>
						{data.providers.data.map((provider) => (
							<ProviderItem
								key={v4()}
								data={{
									...provider,
									info: {},
								}}
								generateProviderRatesUrl={(data) => this.generateProviderRatesUrl(data)}
								linkComponent={<a href={provider.vip_provider_b2b_sat_link} />}
								text={{
									CHECK_COVERAGE: text.connect,
									ELITE_TEXT_1: text.ELITE_TEXT_1,
								}}
								flat={false}
								windowSize={windowSizes}
								generateProviderUrl={() => {}}
								generateLogoPath={(provider) => provider.logo}
								onProviderSelect={() => {}}
								onProviderConnect={() => {
									location.href = provider.vip_provider_b2b_sat_link;
								}}
								ratesView={false}
							/>
						))}
					</Row>
				</Container>
			</PaddingBottom>
		);
	}
}

export default withRouter(
	withDefaultParams(
		graphql(PROVIDERS_QUERY, {
			options: (props) => {
				return {
					variables: {
						filter: `region.url=${props.match.params.regionUrl}&vip_provider_b2b_sat=1`,
						limit: 500,
						offset: 0,
					},
				};
			},
		})(Providers)
	)
);
